import GameRow from './GameRow';
import styles from './CategoriesSection.module.css';
import type { Game, Category } from '../hooks/useGames';
import type { GameLive } from '../hooks/useGamesLive';

interface CategoriesSectionProps {
    categories: Category[];
    categoryIds: string[];
    onGamePlay?: (game: Game) => void | Promise<void>;
    onGameInfo?: (game: Game) => void;
    onGamePromoClick?: (promoUrl: string) => void;
    gamesLive?: GameLive[]; // Array dei giochi live
}

const CategoriesSection = ({
                               categories,
                               categoryIds,
                               onGamePlay,
                               onGameInfo,
                               onGamePromoClick,
                               gamesLive
                           }: CategoriesSectionProps) => {
    // Filtra le categorie in base agli ID forniti e le ordina
    const relevantCategories = categories
        .filter(category => categoryIds.includes(category.id))
        .sort((a, b) => a.order - b.order);

    if (relevantCategories.length === 0) {
        return (
            <div className="text-white text-center py-12">
                <p className="text-xl">Nessuna categoria disponibile</p>
            </div>
        );
    }

    return (
        <div className={styles.categoriesContainer}>
            {relevantCategories.map((category) => {
                // Rimuoviamo la logica di dimensioni diverse - tutte le categorie hanno la stessa grafica
                const size = 'medium';

                return (
                    <div key={category.id} className={styles.categoryRow}>
                        <GameRow
                            title={category.name}
                            description={category.description}
                            games={category.games}
                            size={size}
                            onGamePlay={onGamePlay}
                            onGameInfo={onGameInfo}
                            onGamePromoClick={onGamePromoClick}
                            categoryType={category.type}
                            gamesLive={gamesLive}
                        />
                    </div>
                );
            })}
        </div>
    );
};

export default CategoriesSection;